import React from 'react'
import styled from 'styled-components'
import { formatPrice } from '../../../utils/Utils'

const Container = styled.div`
  width: 100%;
  background: rgba(226,232,236,.30);
  justify-content: flex-start;
  align-items: flex-start;
`
const Table = styled.table`
  width: 100%;
  height: 100%;
  border-spacing:0;
  border-collapse: collapse;
`
const TableRow = styled.tr`
  display: flex;
  justify-content: center;
  width: 100%;
`
const TableHeaderLarge = styled.th`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 4px;
  font-size: 12px;
`
const TableCellLarge = styled.td`
  display: flex;
  flex:3;
  justify-content: center;
  align-items: center;
  padding: 4px;
  font-size: 12px;
`
const Total = styled.div`
  display: flex;
  flex-direction: column;
`
const StrikedText = styled.p`
  margin: 0;
  text-decoration: line-through;
`
const Subcomponent = props => (
  <Container>
    <Table>
      <thead>
        <TableRow>
          <TableHeaderLarge>
            Cantidad
          </TableHeaderLarge>
          <TableHeaderLarge>
            Precio Unitario
          </TableHeaderLarge>
          <TableHeaderLarge>
          {props.row.original.type ==='Charge'&&props.row.original.discount !== undefined && props.row.original.discount !== null ?
            'Descuento'
            :
            ''
          }
          </TableHeaderLarge>
          <TableHeaderLarge>
            Total
          </TableHeaderLarge>
        </TableRow>
      </thead>
      <tbody>
        <TableRow>
          <TableCellLarge>
            {props.row.original.quantity}
          </TableCellLarge>
          <TableCellLarge>
            {formatPrice(props.row.original.unit_price,{symbol:'$'})}
          </TableCellLarge>
          <TableCellLarge >
          {props.row.original.type ==='Charge' && props.row.original.discount !== undefined && props.row.original.discount !== null ?
            formatPrice(props.row.original.discount.discount_amount,{symbol:'$'})
            :
            ''
          }
          </TableCellLarge>
          <TableCellLarge>
          {props.row.original.type ==='Charge' && props.row.original.discount !== undefined && props.row.original.discount !== null ?
          <div>
            <StrikedText>{props.row.original.total_formatted}</StrikedText>
             <span>{formatPrice(props.row.original.discount.new_total, {symbol:'$'})}</span>
          </div>
           :
           props.row.original.total_formatted
          }
          </TableCellLarge>
        </TableRow>
      </tbody>
    </Table>
  </Container>
)

export default Subcomponent



// WEBPACK FOOTER //
// ./src/Components/ParentPlatform/BalanceTable/Subcomponent.jsx